import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import ProductsSelect from 'src/components/ProductsSelect';
import TextField from 'src/components/TextField';
import { OrderExpeditionPackageType } from 'src/types/orderExpeditionPackage';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: OrderExpeditionPackageType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.ID_ORDER}
                    name="ID_ORDER"
                    label={translate('orderExpeditionPackageDetail.order')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.EXP_PCKG}
                    name="EXP_PCKG"
                    label={translate('orderExpeditionPackageDetail.expeditionPackage')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={props.editData.TRACKING_NUMBER}
                    error={props.editErrors.TRACKING_NUMBER}
                    onChange={(value, error) => props.onChange('TRACKING_NUMBER', value, error)}
                    name="TRACKING_NUMBER"
                    label={translate('orderExpeditionPackageDetail.trackingNumber')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={props.editData.WIDTH}
                    error={props.editErrors.WIDTH}
                    onChange={(value, error) => props.onChange('WIDTH', value, error)}
                    name="WIDTH"
                    label={translate('orderExpeditionPackageDetail.width')}
                    type="numberLocale"
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={props.editData.HEIGHT}
                    error={props.editErrors.HEIGHT}
                    onChange={(value, error) => props.onChange('HEIGHT', value, error)}
                    name="HEIGHT"
                    label={translate('orderExpeditionPackageDetail.height')}
                    type="numberLocale"
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={props.editData.LENGTH}
                    error={props.editErrors.LENGTH}
                    onChange={(value, error) => props.onChange('LENGTH', value, error)}
                    name="LENGTH"
                    label={translate('orderExpeditionPackageDetail.length')}
                    type="numberLocale"
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={props.editData.WEIGHT}
                    error={props.editErrors.WEIGHT}
                    onChange={(value, error) => props.onChange('WEIGHT', value, error)}
                    name="WEIGHT"
                    label={translate('orderExpeditionPackageDetail.weight')}
                    type="numberLocale"
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={12}>
                <ProductsSelect
                    value={props.editData.PCKG_SKU}
                    error={props.editErrors.PCKG_SKU}
                    idKey="SKU"
                    onChange={(value: any, error) => props.onChange('PCKG_SKU', value.SKU, error)}
                    productTypes={['packagingMaterial']}
                    name="PCKG_SKU"
                    label={translate('orderExpeditionPackageDetail.package')}
                    fullWidth
                    disabled={props.disableEdit}
                    required
                />
            </GridItem>
            <GridItem cols={12}>
                <ProductsSelect
                    value={props.editData.PALLET_SKU}
                    error={props.editErrors.PALLET_SKU}
                    idKey="SKU"
                    onChange={(value: any, error) => props.onChange('PALLET_SKU', value.SKU, error)}
                    productTypes={['packagingMaterial']}
                    name="PALLET_SKU"
                    label={translate('orderExpeditionPackageDetail.pallet')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
